import Rails from '@rails/ujs';
export default Rails;
window.Rails || Rails.start();
